import { IWasteReceiptRow, WasteReceiptStatus } from "../../models/wasteTracking/IWasteReceiptRow";
import StatusPill, { StatusPillColour } from "../shared/StatusPill";

// One pill for a receipt's state, shared by the Waste Tracking table and the account history tab.
export default function WasteReceiptStatusPill({ row }: { row: IWasteReceiptRow }) {
  if (row.status === WasteReceiptStatus.Submitted) return <StatusPill text="Submitted" colour={StatusPillColour.Green} />;
  if (row.status === WasteReceiptStatus.Amended) return <StatusPill text="Amended" colour={StatusPillColour.Blue} />;
  if (row.status === WasteReceiptStatus.Excluded) return <StatusPill text="Excluded" colour={StatusPillColour.Neutral} />;
  if (row.status === WasteReceiptStatus.Failed) return <StatusPill text="Rejected" colour={StatusPillColour.Red} />;
  if (row.isReady) return <StatusPill text="Ready" colour={StatusPillColour.Green} />;
  return <StatusPill text="Missing data" colour={StatusPillColour.Yellow} />;
}
